import _classCallCheck from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Grid from "@material-ui/core/Grid";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MenuIcon from "@material-ui/icons/Menu";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { fromJS } from "immutable";
import DefiHeaderLogo from "./DefiHeaderLogo";

var nullify = function nullify() {
  return null;
};

var styles = function styles(theme) {
  return {
    button: {
      textTransform: "none",
      float: "right",
      height: "48px",
      color: "#fff",
      fontSize: 14
    },
    header: {
      maxWidth: 315,
      maxHeight: 52
    },
    mobileHeader: {
      maxWidth: 170,
      maxHeight: 52
    },
    buttonMenu: {
      margin: theme.spacing(1),
      textTransform: "none",
      float: "left",
      height: "48px",
      color: "#fff"
    },
    input: {
      margin: "0px -3px",
      backgroundColor: "#fff",
      width: "100%",
      fontSize: "14px",
      padding: "5px 1px"
    },
    toolbar: {
      backgroundColor: "#334058",
      color: "#fff",
      height: "68px"
    },
    appBar: {
      // position: 'fixed',
      width: "100%",
      zIndex: 1200
    }
  };
};

var DefiHeader =
/*#__PURE__*/
function (_Component) {
  _inherits(DefiHeader, _Component);

  function DefiHeader(props) {
    var _this;

    _classCallCheck(this, DefiHeader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DefiHeader).call(this, props));

    _this.setMediaData = function () {
      var mql = window.matchMedia("(min-width: ".concat(_this.props.mobileWidth, "px)"));

      _this.setState({
        mql: mql,
        mobileStatus: !mql.matches
      });
    };

    _this.handleToggleMenu = function (bool, e) {
      _this.setState({
        menuOpen: bool,
        menuAnchorEl: e ? e.currentTarget : null
      });
    };

    _this.renderMobileMenuItems = function () {
      return _this.props.right.map(function (link, i) {
        if (link.has("condition") && !link.get("condition")) {
          return null;
        }

        if (link.get("type") === "input") {
          return React.createElement("div", {
            key: i,
            style: {
              padding: "4px 16px"
            }
          }, React.createElement("form", {
            onSubmit: link.get("submit") || nullify
          }, React.createElement("input", {
            type: "text",
            placeholder: "Application Search",
            className: _this.props.classes.input,
            onChange: link.get("onChange") || nullify
          })));
        }

        return React.createElement(MenuItem, {
          key: i,
          style: {
            cursor: "default"
          }
        }, React.createElement("a", {
          style: {
            cursor: "pointer",
            color: "inherit",
            textDecoration: "none"
          },
          href: link.get("link") || "#",
          onClick: link.get("onClick") || nullify
        }, link.get("name")));
      });
    };

    _this.renderMobileRight = function () {
      var right = _this.props.right;

      if (right && right.size > 0) {
        return React.createElement("div", null, React.createElement(IconButton, {
          "aria-label": "More",
          "aria-owns": "mobile-menu",
          "aria-haspopup": "true",
          onClick: function onClick(e) {
            return _this.handleToggleMenu(true, e);
          },
          className: _this.props.classes.button
        }, React.createElement(MoreVertIcon, null)), React.createElement(Menu, {
          id: "mobile-menu",
          anchorEl: _this.state.menuAnchorEl,
          open: _this.state.menuOpen,
          onClose: function onClose() {
            return _this.handleToggleMenu(false);
          },
          style: {
            zIndex: 1600
          }
        }, _this.renderMobileMenuItems()));
      }
    };

    _this.renderDesktopRight = function () {
      var classes = _this.props.classes;
      return _this.props.right.reverse().map(function (link, i) {
        if (link.has("condition") && !link.get("condition")) {
          return null;
        }

        if (link.get("mobileOnly")) {
          return null;
        }

        if (link.has("icon")) {
          return React.createElement(IconButton, {
            key: i,
            className: classes.button,
            "aria-label": link.get("name"),
            onClick: link.get("onClick") || nullify
          }, link.get("icon").toJS());
        }

        return React.createElement(Button, {
          key: i,
          className: classes.button,
          href: link.get("link") || "",
          onClick: link.get("onClick") || nullify
        }, link.get("name"));
      });
    };

    _this.renderGridItems = function () {
      var _this$props = _this.props,
          classes = _this$props.classes,
          logo = _this$props.logo,
          logoLink = _this$props.logoLink;

      var sidebarIcon = function sidebarIcon() {
        if (_this.props.toggleSidebar) {
          return React.createElement(Grid, {
            item: true
          }, React.createElement(IconButton, {
            "data-testid": "sidebar-icon",
            className: classes.buttonMenu,
            "aria-label": "Logout",
            onClick: function onClick() {
              return _this.props.toggleSidebar();
            }
          }, React.createElement(MenuIcon, {
            focusable: "focusable"
          })));
        }
      };

      if (_this.state.mobileStatus) {
        return React.createElement(React.Fragment, null, React.createElement(Grid, {
          item: true,
          xs: 3
        }, sidebarIcon()), React.createElement(Grid, {
          item: true,
          xs: 6
        }, React.createElement(Grid, {
          container: true,
          alignItems: "center",
          justify: "center"
        }, logo && React.createElement(DefiHeaderLogo, {
          logo: logo,
          logoLink: logoLink,
          className: classes.mobileHeader
        }))), React.createElement(Grid, {
          item: true,
          xs: 3
        }, _this.renderMobileRight()));
      }

      return React.createElement(React.Fragment, null, React.createElement(Grid, {
        item: true,
        xs: 5
      }, React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, sidebarIcon(), logo && React.createElement(DefiHeaderLogo, {
        logo: logo,
        logoLink: logoLink,
        className: classes.header
      }))), React.createElement(Grid, {
        item: true,
        xs: 3
      }, React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, _this.props.center)), React.createElement(Grid, {
        item: true,
        xs: 4
      }, _this.renderDesktopRight()));
    };

    _this.mql = window.matchMedia("(min-width: ".concat(props.mobileWidth, "px)"));
    _this.state = {
      mql: _this.mql,
      menuOpen: false,
      menuAnchorEl: undefined,
      mobileStatus: _this.mql.matches
    };
    return _this;
  }

  _createClass(DefiHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (localStorage.mobile === "false") {
        return this.setState({
          mobileStatus: false
        });
      }

      this.state.mql.addListener(this.setMediaData);
      this.setMediaData();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.mobileWidth !== this.props.mobileWidth) {
        if (localStorage.mobile !== "false") {
          this.mql.removeListener(this.setMediaData);
          this.mql = window.matchMedia("(min-width: ".concat(this.props.mobileWidth, "px)"));
          this.mql.addListener(this.setMediaData);
          this.setMediaData();
        }
      }
    } // componentWillUnmount() {
    //   this.state.mql.removeListener(this.setMediaData);
    // }

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          headerContainerClass = _this$props2.headerContainerClass;
      return React.createElement("div", {
        className: headerContainerClass
      }, React.createElement(AppBar, {
        "data-testid": "defi-header",
        className: classes.appBar,
        onClick: this.props.headerClick,
        position: this.props.position
      }, React.createElement(Toolbar, {
        className: classes.toolbar
      }, React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, this.renderGridItems()))));
    }
  }]);

  return DefiHeader;
}(Component);

DefiHeader.defaultProps = {
  right: fromJS([]),
  toggleSidebar: null,
  center: null,
  headerClick: nullify,
  mobileWidth: 1250,
  logo: "",
  logoLink: "",
  position: "fixed"
};
export default withStyles(styles)(DefiHeader);